import scan_icon from './img/scan_icon.svg';
import print_icon from './img/print_icon.svg';
import arhive_icon from './img/archive_icon.svg';
import { CardOrder } from '../../components/CardsComponents/CardOrder/CardOrder';
import { useParams } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { fetchOrdersFilter } from '../../common/filtersFunc';
import { useState, useEffect, useRef } from 'react';
import { ButtonWithIcon } from '../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import {
  DropDownSelector,
  TableBox,
  Tabs,
  ButtonBasic,
} from '@lk-gtcom/ecomlab-components';
import './Deliveries.scss';
import useGeneralStore from '../../store/general';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { options_prop_mp } from '../../common/globalVariables';
import { periodWeek } from '../../common/constant';


const btn_tab = [
  { label: 'Ожидает упаковки', value: 'awaiting_packaging' },
  { label: 'Список поставок', value: 'supply_list' },
  { label: 'Ожидает доставки', value: 'awaiting_delivery' },
];

const Deliveries = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  const activeTab = useParams()['*'];
  const [pageValue, setPageValue] = useState(btn_tab[0]);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [warehousePage, setWarehousePage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [warehouseQuery, setWarehouseQuery] = useState('');

  const [apiData, setApiData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([]);
  const [selectedApi, setSelectedApi] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setFilters } =
    setTableFuncs;

  useEffect(() => {
    const abortController = new AbortController();

    fetchOrdersFilter({
      selectedSpace: selectedSpace?.value,
      target: 'api_id',
      type: selectedMarketplace?.value,
      page: apiPage,
      setData: (e) => setApiData(e),
      searchParam: apiQuery,
      categoryData,
      selectedCategory,
      brandData,
      selectedBrand,
      warehouseData,
      selectedWarehouse,
      dateFrom,
      dateTo,
      withAll: false,
      abortController,
    });

    return () => abortController.abort();
  }, [
    selectedCategory,
    selectedBrand,
    selectedWarehouse,
    selectedMarketplace,
    apiPage,
    apiQuery,
    dateFrom,
    dateTo,
  ]);

  useEffect(() => {
    const abortController = new AbortController();

    fetchOrdersFilter({
      selectedSpace: selectedSpace?.value,
      target: 'category',
      type: selectedMarketplace?.value,
      page: categoryPage,
      apiData,
      dateFrom,
      dateTo,
      selectedApi,
      setData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      apiData,
      selectedApi,
      brandData,
      selectedBrand,
      warehouseData,
      selectedWarehouse,
      abortController,
    });

    return () => abortController.abort();
  }, [
    selectedApi,
    selectedBrand,
    selectedWarehouse,
    dateFrom,
    dateTo,
    categoryPage,
    categoryQuery,
    selectedMarketplace,
  ]);

  useEffect(() => {
    const abortController = new AbortController();

    fetchOrdersFilter({
      selectedSpace: selectedSpace?.value,
      target: 'brand',
      type: selectedMarketplace?.value,
      page: brandPage,
      apiData,
      categoryData,
      selectedCategory,
      dateFrom,
      dateTo,
      searchParam: brandQuery,
      selectedApi,
      setData: (e) => setBrandData(e),
      apiData,
      selectedApi,
      categoryData,
      selectedCategory,
      warehouseData,
      selectedWarehouse,
      abortController,
    });

    return () => abortController.abort();
  }, [
    selectedSpace,
    selectedApi,
    selectedCategory,
    selectedWarehouse,
    selectedMarketplace,
    brandPage,
    brandQuery,
    dateFrom,
    dateTo,
  ]);

  useEffect(() => {
    const abortController = new AbortController();

    fetchOrdersFilter({
      selectedSpace: selectedSpace?.value,
      target: 'warehouse',
      type: selectedMarketplace?.value,
      page: warehousePage,
      apiData,
      warehouseData,
      selectedApi,
      selectedWarehouse,
      searchParam: warehouseQuery,
      setData: (e) => setWarehouseData(e),
      apiData,
      selectedApi,
      categoryData,
      selectedCategory,
      brandData,
      selectedBrand,
      abortController,
    });

    return () => abortController.abort();
  }, [
    selectedSpace,
    selectedApi,
    selectedCategory,
    selectedBrand,
    selectedMarketplace,
    warehousePage,
    warehouseQuery,
    dateFrom,
    dateTo,
  ]);

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  return (
    <div className="deliveries">
      <TitlePage
        title='Поставки'
      />

      <FilterContainer
        onReset={(e) => {
          setSelectedApi([]);
          setSelectedCategory([]);
          setSelectedBrand([]);
          setSelectedWarehouse([]);
        }}
      >
        <DropDownSelector
          options_prop={options_prop_mp}
          state={selectedMarketplace}
          setState={setSelectedMarketplace}
          placeholder="Площадка"
          defaultValue={options_prop_mp[0]}
        />

        <DropDownSelector
          options_prop={apiData}
          state={selectedApi}
          setState={setSelectedApi}
          placeholder="Магазин"
          fetchCallback={setApiPage}
          setInputChange={setApiQuery}
        />

        <DropDownSelector
          options_prop={warehouseData}
          state={selectedWarehouse}
          setState={setSelectedWarehouse}
          placeholder="Склад"
          fetchCallback={setWarehousePage}
          setInputChange={setWarehouseQuery}
          defaultValue={[{ label: 'Все', value: 'all' }]}
        />

        <DropDownSelector
          options_prop={categoryData}
          state={selectedCategory}
          setState={setSelectedCategory}
          placeholder="Категория"
          fetchCallback={setCategoryPage}
          setInputChange={setCategoryQuery}
          defaultValue={[{ label: 'Все', value: 'all' }]}
        />

        <DropDownSelector
          options_prop={brandData}
          state={selectedBrand}
          setState={setSelectedBrand}
          placeholder="Бренд"
          fetchCallback={setBrandPage}
          setInputChange={setBrandQuery}
          defaultValue={[{ label: 'Все', value: 'all' }]}
        />
      </FilterContainer>

      <Tabs tabs={btn_tab} pageValue={pageValue} />

      <TableBox
        ref={paginatorRef}
        {...tableProps}
        paginator={true}
        child={
          <>
            <ButtonWithIcon
              whiteGreen
              label='Сканировать'
              icon={scan_icon}
            />

            <ButtonWithIcon
              whiteGreen
              label='Выгрузить заказы'
              icon={arhive_icon}
            />

            <ButtonWithIcon
              whiteGreen
              label='Распечатать лист подбора'
              icon={print_icon}
            />
            <ButtonBasic
              action
              size="32px"
              text="Создать новую поставку"
              width="fit-content"
              onClick={(e) => e}
            />

            <ButtonBasic
              grey
              size="32px"
              text="Добавить в поставку"
              width="fit-content"
              onClick={(e) => e}
            />
          </>
        }
      />
    </div>
  );
};

export { Deliveries };
